
import { v4 as uuidv4 } from "uuid";
import { 
  CharacterASIFeature,
} from "@dndModels/character_feature";
import { 
  CharacterFeat,
  ASIBaseFeature 
} from "@dndModels";

/**
 * 
 */
export class CharacterASIBaseFeature {
  asi_base_feature: ASIBaseFeature | null = null;
  true_id = "";
  // id: number;
  feat_option = false;
  use_feat: boolean | null = null;
  feat: CharacterFeat = new CharacterFeat();
  asi_features: CharacterASIFeature[] = [];
  source_type = "";
  selected_choice_id = "";

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    if (obj) {
      // this.id = obj && obj.id ? obj.id : -1;
      this.feat_option = obj ? obj.feat_option : false;
      this.use_feat = obj ? obj.use_feat : null;
      this.feat = obj && obj.feat ? new CharacterFeat(obj.feat) : new CharacterFeat();
      this.asi_features = [];
      if (obj && obj.asi_features) {
        obj.asi_features.forEach((o: any) => {
          const feature = new CharacterASIFeature(o);
          // feature.id = this.asi_features.length;
          this.asi_features.push(feature);
        });
      }
      this.selected_choice_id = obj && obj.selected_choice_id ? obj.selected_choice_id : "";
      this.asi_base_feature = obj && obj.asi_base_feature ? new ASIBaseFeature(obj.asi_base_feature) : null;
    }
  }

  toDBObj(): any {
    // const asi_features: any[] = [];
    // this.asi_features.forEach(f => {
    //   asi_features.push(f.toDBObj());
    // });
    return {
      true_id: this.true_id,
      feat_option: this.feat_option,
      use_feat: this.use_feat,
      feat: this.feat.toDBObj(),
      asi_features: this.asi_features.map(o => o.toDBObj()),
      selected_choice_id: this.selected_choice_id
    };
  }

  clone() {
    const new_obj = new CharacterASIBaseFeature();
    new_obj.copy(this);
    return new_obj;
  }

  copy(copyMe: CharacterASIBaseFeature): void {
    this.true_id = copyMe.true_id;
    this.asi_base_feature = new ASIBaseFeature(copyMe.asi_base_feature);
    // this.id = copyMe.id;
    this.feat_option = copyMe.feat_option;
    this.use_feat = copyMe.use_feat;
    this.feat = copyMe.feat;
    this.asi_features = copyMe.asi_features.map(o => o.clone());
    this.selected_choice_id = copyMe.selected_choice_id;
  }

  copyASIBaseFeature(copyMe: ASIBaseFeature): void {
    this.asi_base_feature = new ASIBaseFeature(copyMe);
    this.feat_option = copyMe.feat_option;
    this.use_feat = null;
    this.feat = new CharacterFeat();
    this.asi_features = [];
    // console.log(copyMe);
    // console.log(this.clone());
    if (copyMe.choices.length === 1) {
      this.selected_choice_id = copyMe.choices[0].true_id;
      for (const asif of copyMe.asi_features) {
        const feature = new CharacterASIFeature();
        feature.copyASIFeature(asif);
        // feature.id = this.asi_features.length;
        this.asi_features.push(feature);
      }
    }
  }

  connectASIBaseFeature(copyMe: ASIBaseFeature): void {
    this.asi_base_feature = copyMe;
    // console.log(copyMe);
    // console.log(this.clone());
    const choice = copyMe.choices.length === 1 ? copyMe.choices[0] : copyMe.choices.find(o => o.true_id === this.selected_choice_id);
    if (choice) {
      if (this.asi_features.length !== choice.asi_features.length) {
        this.asi_features = [];
        for (const asif of choice.asi_features) {
          const feature = new CharacterASIFeature();
          feature.copyASIFeature(asif);
          // feature.id = this.asi_features.length;
          this.asi_features.push(feature);
        }
      } 
    } else {
      this.asi_features = [];
    }
  }
}